import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class AutoInsurancePhotoUrl extends _BaseUserProfile {
  component = 'PhotoField';
  props = {
    title: 'Please take / upload a photo of your auto insurance:',
    errorMessage: 'Photo is Required',
    additionalFormInModal: false,
  };
  hideClearUntilValue = true;
}
